import React from 'react';
import {Form, FormInstance, Input, Radio} from 'antd';
import { ServiceInfo, ServiceType } from '../entities/ServiceInfo';

interface ServiceInfoFormProps {
    form: FormInstance;
    serviceInfo: ServiceInfo | null;
    create: boolean;
}

const ServiceInfoForm: React.FC<ServiceInfoFormProps> = ({form, serviceInfo, create }) => {
    return (
        <Form form={form} layout="vertical" initialValues={{...serviceInfo}}>
            <Form.Item
                name="appKey"
                label="AppKey"
                rules={[{ required: true, message: '请输入AppKey！' },
                    { pattern: /^[a-zA-Z.]+$/, message: '只支持英文和.，不超过50字' }
                ]}>
                <Input placeholder="只支持小写英文和.，不超过50字" disabled={!create} />
            </Form.Item>
            <Form.Item
                name="name"
                label="服务名称"
                rules={[{ required: true, message: '请输入服务名称！' }]}>
                <Input placeholder="中英文描述，不超过20字" />
            </Form.Item>
            <Form.Item
                name="type"
                label="服务类型"
                rules={[{ required: true, message: '请选择服务类型！' }]}>
                <Radio.Group disabled={!create}>
                    <Radio value={ServiceType[ServiceType.SPRINGBOOT]}>Spring Boot</Radio>
                    <Radio value={ServiceType[ServiceType.NODEJS]}>Node.js</Radio>
                    <Radio value={ServiceType[ServiceType.COCOS]}>Cocos</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item
                name="gitUrl"
                label="Git clone地址"
                rules={[{ required: true, message: '请输入Git克隆地址！' }]}>
                <Input placeholder="比如git@codeup.aliyun.com:63aec684d690c872dcef24bd/com.haiskynology.microservice.center.nginx.git" />
            </Form.Item>
            <Form.Item
                name="description"
                label="服务描述">
                <Input.TextArea placeholder="不超过300字" />
            </Form.Item>
        </Form>
    );
};

export default ServiceInfoForm;